export const FormFields = {
  status: 'status',
  isAbleToManagePlatformStaff: 'isAbleToManagePlatformStaff',
} as const;
